var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { markRaw, createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }, [
      createElementVNode("path", { d: "M9.183 6.117a6 6 0 1 0 4.511 3.986" }),
      createElementVNode("path", { d: "M14.813 17.883a6 6 0 1 0-4.496-3.954" })
    ], -1)
  ]));
}
__name(render, "render");
const circlesRelation = markRaw({ name: "tabler-circles-relation", render });
export {
  circlesRelation as default
};
//# sourceMappingURL=circles-relation.js.map
